import React from 'react';
import PropTypes from 'prop-types';

// app
import styles from './EditProductsClient.styles';
import { Form } from 'components';

// mui
import { makeStyles } from '@material-ui/core';

EditProductsClientView.propTypes = {
  fields: PropTypes.array.isRequired,
  actions: PropTypes.array.isRequired,
  defaultValues: PropTypes.object.isRequired,
  validationSchema: PropTypes.object.isRequired,
};

export function EditProductsClientView({ fields, actions, defaultValues, validationSchema }) {
  const classes = makeStyles(styles, { name: 'EditProductsClient' })();

  return (
    <div className={classes.root}>
      <Form
        id="edit-products-client"
        type="dialog"
        fields={fields}
        actions={actions}
        defaultValues={defaultValues}
        validationSchema={validationSchema}
      />
    </div>
  );
}
